import type { SVGProps } from "react";
import * as React from "react";

const SvgArrowDownRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.707 6.293a1 1 0 0 0-1.414 1.414zM17 17v1a1 1 0 0 0 1-1zm1-10a1 1 0 1 0-2 0zM7 16a1 1 0 1 0 0 2zm-.707-8.293 10 10 1.414-1.414-10-10zM16 7v10h2V7zm1 9H7v2h10z"
    />
  </svg>
);
export default SvgArrowDownRight;
